/**
 * 功能：业务错误处理
 * 参数：
 *  error:
 *  {
 *    showInMessage: 显示在Message窗口（默认：true)
 *  }
 */
import { Message, MessageBox } from "element-ui";
import { randomCode } from "@/utils/common";

export function handleError(response, config) {
  // 是否有错误
  if (response.data.success == true) {
    return;
  }
  // 错误处理
  switch (response.data.resultCode) {
    // 未登录/登录超时
    case "910":
      processLoginError();
      break;
    // 登录禁用
    case "LOGN_914":
      processLoginValid();
      break;
    default:
      processDefault(response, config);
      break;
  }
}

// 默认
function processDefault(response, config) {
  // 获取参数
  const showInMessage =
    config && config.showInMessage != undefined ? config.showInMessage : true;
  // 在Message中提示错误
  if (showInMessage == true) {
    Message({
      message: response.data.message || "【未知错误】",
      type: "error"
    });
  }
}

// 未登录/登录超时
let loginErrorWindow = null;
function processLoginError() {
  // 不再重复打开弹窗
  if (loginErrorWindow) {
    return;
  }
  // 打开弹窗
  loginErrorWindow = MessageBox.confirm("用户未登录, 是否重新登录？", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
    confirmButtonClass: "standard-btn",
    cancelButtonClass: "simple-btn"
  })
    .then(() => {
      // window.open(`${process.env.VUE_APP_URL}/login`, "_self", "", true);
      const a = randomCode(1);
      window.open(`${process.env.VUE_APP_URL}/login`, "_self", a);
    })
    .finally(() => {
      loginErrorWindow = null;
    });
}

// 登录禁用
function processLoginValid() {
  MessageBox.alert(
    "<div><p>您的账号已被禁用</p><p>请联系管理员修改您的账号状态</p></div>",
    "提示",
    {
      dangerouslyUseHTMLString: true,
      confirmButtonText: "我知道了",
      showCancelButton: false,
      center: true,
      confirmButtonClass: "standard-btn",
      closeOnClickModal: true,
      closeOnPressEscape: true
    }
  );
}



// WEBPACK FOOTER //
// ./src/utils/request/error.js